import Component from '@glimmer/component';

import { get } from '@ember/helper';
import { action } from '@ember/object';
import LinkToAction from 'ember-route-state/components/link-to-action.gjs';
import { tracked } from 'tracked-built-ins';

import TabPanelTab from 'rise-ui/components/tab-panel/tab.gjs';
import call from 'rise-ui/helpers/call.js';
import eq from 'rise-ui/helpers/eq.js';
import fnx from 'rise-ui/helpers/fnx.js';
import { fn, readOnly } from 'rise-ui/utils/object/computed.js';
import one from 'rise-ui/helpers/one.js';

export default class TabPanelComponent extends Component {
  tabs = tracked([]);
  tabsByName = tracked({});

  @fn('args.linkTo') linkToTab;
  get selectedTab() {
    const { selected, tabs } = this; // Consume
    const { name } = tabs?.[0] ?? {}; // Consume
    return selected || name;
  }
  @readOnly('onSelect') onLinkToAction;

  @tracked selected;
  @action setSelectedTab(name) {
    this.selected = name;
  }

  @action async setTab(name, tab) {
    await Promise.resolve(); // Prevent write after render
    if (!this.tabsByName[name]) {
      tab = this.tabsByName[name] = { name, ...tab };
      this.tabs.push(tab);
    } else if (this.tabsByName[name].title !== tab.title) {
      const index = this.tabs.indexOf(this.tabsByName[name]);
      tab = this.tabsByName[name] = { ...this.tabsByName[name], ...tab };
      this.tabs.splice(index, 1, [tab]);
    }
  }

  <template>
    {{#let
      (one @selected this.selected (get this.tabs "0.name"))
      as | selectedTab |
    }}
    <div class="r-tabs">
      <ul class="r-tabs-nav">
        {{#each this.tabs as | tab |}}
          <li class="r-tabs-tab r-tabs-state-{{if (eq selectedTab tab.name) "active" "default"}}">
            <LinkToAction @class="r-tabs-anchor"
              @linkTo={{call this.linkToTab tab.name}}
              @action={{fnx this.setSelectedTab tab.name}}
            >
              {{~tab.title~}}
            </LinkToAction>
          </li>
        {{/each}}
      </ul>
      {{#each this.tabs as | tab |}}
        <div class="r-tabs-accordion-title r-tabs-state-{{if (eq this.selectedTab tab.name) "active" "default"}}">
          <LinkToAction @class="r-tabs-anchor"
            @linkTo={{call this.linkToTab tab.name}}
            @action={{fnx this.setSelectedTab tab.name}}
          >
            {{tab.title}}
          </LinkToAction>
        </div>
      {{/each}}
      {{yield (component TabPanelTab setTab=this.setTab selectedTab=selectedTab)}}
    </div>
    {{/let}}
  </template>
}
